var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"mark-as-seen-button",class:[
		{ 'light-background': _setup.props.lightBackground, 'is-marked': _setup.props.isMarked },
		`mark-as-seen-button--${_setup.props.size}`,
	],attrs:{"role":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('mark-as-seen-button-click')}}},[(!_vm.saving)?_c('FontAwesomeIcon',{staticClass:"seen-icon",class:{ 'seen-icon--seen': _vm.isMarked },attrs:{"icon":_setup.FA_ICONS[_vm.icon]}}):_vm._e(),(_vm.saving)?_c('ion-spinner',{attrs:{"color":"light"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }